function getEmptyPropsList(source) {
  return Object.keys(source).filter((key) => {
    const value = source[key];
    return value === void 0 || value === null || Array.isArray(value) && value.length === 0;
  });
}
export {
  getEmptyPropsList as g
};
